import React from 'react';

// mui core components
import Divider from "@material-ui/core/Divider";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";

const Transition = (props) => {
    return <Slide direction="down" {...props} />
}

const UserPromptModal = ({ children, isOpen, closeModal, yesFunc, noFunc }) => (
    <Dialog
        style={{ height: "auto" }}
        open={isOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={closeModal}
        aria-labelledby="add-order-user-prompt"
        aria-describedby="add-order-user-prompt"
        maxWidth='sm'
        fullWidth
    >
        <DialogContent>

            <GridContainer>
                {children}
            </GridContainer>
            <GridContainer justify='space-between'>
                <GridItem xs={12}>
                    <Divider />
                    <br />
                </GridItem>
                <GridItem>
                    <Button
                        color="info"
                        onClick={noFunc}
                    >
                        NO
                    </Button>
                </GridItem>
                <GridItem>
                    <Button
                        color="primary"
                        onClick={yesFunc}
                    >
                        YES
                    </Button>
                </GridItem>
            </GridContainer>

        </DialogContent>
    </Dialog>
)

export default UserPromptModal;


// WEBPACK FOOTER //
// ./src/components/Modal/UserConfirm.jsx